<template>
    <h4 class="border-bottom p-3 mb-0">Are you still there?</h4>
    <p class="border-bottom p-3 pb-4 mb-0">
        You have been idle for a while. For security reasons, your session will expire in
        <strong>{{ minutes }}:{{ seconds }}</strong>
    </p>
    <div class="d-flex justify-content-end p-3">
        <button type="button" class="btn btn-light border border-secondary me-1" @click="logout()">Log out</button>
        <button type="button" class="btn btn-primary border border-primary" @click="stayLoggedIn()">
            Stay Logged In
        </button>
    </div>
</template>

<script lang="ts" src="./IdleTimeout.ts"></script>
